// export async function getCountry(): Promise<string> {
//   try {
//     // Use ipapi.co for free geolocation lookup
//     const response = await fetch('https://ipapi.co/json/');
//     const data = await response.json();
//     return data.country_name || 'Unknown';
//   } catch (error) {
//     console.error('Error fetching country:', error);
//     return 'Unknown';
//   }
// }

export async function getCountry(): Promise<string> {
  try {
    const response = await fetch("https://ipapi.co/json/");

    if (!response.ok) {
      console.error(
        "❌ Response not OK:",
        response.status,
        response.statusText
      );
      return "Unknown";
    }

    const data = await response.json();

    const country = data.country_name || "Unknown";

    return country;
  } catch (error) {
    console.error("❌ === getCountry() ERROR ===");
    console.error("❌ Error type:", error?.constructor?.name);
    console.error("❌ Error message:", error);
    console.error("❌ Full error:", JSON.stringify(error, null, 2));

    return "Unknown";
  }
}
